export const CRUD_READ_PENDING = 'CRUD_CLUBS_READ_PENDING'
export const CRUD_READ_SUCCEEDED = 'CRUD_CLUBS_SUCCEEDED'
export const CRUD_READ_FAILED = 'CRUD_CLUBS_READ_FAILED'
